// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logo_logoContainer_13ybk","logo":"logo_logo_hW2N7","xs":"logo_xs_33QAh","s":"logo_s_1NuAb","m":"logo_m_1ln0j","l":"logo_l_1F3I5","logoText":"logo_logoText_2b6df"};